import { getMockExamApi } from "@/api/services/admin/learning-content";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

/**
 * Custom hook for fetching a single mock exam by industry ID + mock exam ID.
 * Returns null data gracefully when no mock exam exists (404).
 */
export const useMockExam = (industryId?: string, mockExamId?: string) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_MOCK_EXAM, industryId, mockExamId],
    queryFn: () => getMockExamApi(industryId!, mockExamId!),
    enabled: Boolean(industryId) && Boolean(mockExamId),
    retry: (failureCount, error) => {
      if (axios.isAxiosError(error) && error.response?.status === 404) return false;
      return failureCount < 3;
    },
  });

  return {
    data: query.data?.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
